import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Modal, Col, Row, Container, Tabs, Tab } from "react-bootstrap";
import {
  openEventChooser,
  initiateCreateEvent,
  logout,
  markLogin,
} from "Actions";
import { DEVELOPMENT_TYPE } from "Constants";
import {
  fetchtotalaccountusageofclient,
  fetchClientalldetails,
} from "AccountSettingsAction";
import { selectDashboardMenu } from "DashboardMenuAction";
import EventItem from "./components/eventitem";
import Choose from "Choose";
import LocaleStrings from "Languages";
import Loader from "Loader";

class EventChooser extends Component {
  constructor(props) {
    super(props);
    //const cookies = new Cookies();

    this.state = {
      loading: false,
      selectedTab: 1,
      eventDeleted: false, // this state is used to hide modal close button after delete any event
      checkClientuserlimitandexpiry: false,
    };
  }

  componentDidMount() {
    let { user } = this.props;

    // this.props.checkClientExpiryDate(
    //   this.props.event.eventid,
    //   this.props.session,
    //   (response) => {
    //     if (response.success == 1) {

    //       if(response && response.data && response.data.userlimitexceeded == true){
    //         this.props.showError('Userlimit has expired for this client!');
    //       }else{
    //         this.props.refreshSessionToken(
    //           this.props.session,
    //           { appuserid: this.props.event.appuserid },
    //           (res) => {
    //             this.props.loginToEvent(this.props.event);
    //             this.props.proceedToDashboard();
    //             this.props.openEventChooser({ showModal: false });
    //             this.props.isEventDeleted(false); // update parent components state to handle close modal button.
    //             if (this.props.insideDashBoard === true) {
    //               this.props.history.push("/");
    //             } else {
    //               this.props.history.push("/dashboard");
    //             }
    //           }
    //         );
    //       }

    //     } else {
    //       this.props.showError(LocaleStrings.login_user_session_expired);
    //     }
    //   }
    // );
    // if (user && user.clientid != "") {
    //   this.props.fetchtotalaccountusageofclient(
    //     this.props.session,
    //     user.clientid
    //   );
    //   this.props.fetchClientalldetails(
    //     this.props.session,
    //     user.clientid
    //   );
    // }
  }

  updateEventDelete = (bool) => {
    this.setState({ eventDeleted: bool });
  };

  renderEventItems() {
    var items = [];

    this.props.events.data.map((item, index) => {
      items.push(
        <Col md={4} key={item.eventid}>
          <EventItem
            key={index}
            event={{ ...item, addevent: false }}
            insideDashBoard={this.props.insideDashBoard}
          />
        </Col>
      );
    });

    if (
      DEVELOPMENT_TYPE === "eventify" &&
      this.props.insideDashBoard === false &&
      this.props.user &&
      this.props.user.isSuperAdmin &&
      (this.props.user.allowedEvent < 0 ||
        this.props.user.allowedEvent > this.props.user.totalCreatedEvents)
    ) {
      var addeventitem = (
        <Col md={4} key="addevent">
          <EventItem key="0" event={{ themecolor: "", addevent: true }} />
        </Col>
      );

      items.push(addeventitem);
    }

    return items;
  }

  renderUpcomingEventItems() {
    let { events, user, insideDashBoard } = this.props;
    var upCommingEventItems = [];

    if (events.data && events.data.length > 0) {
      events.data.filter(filterUpcommingEvents).map((item, index) => {
        upCommingEventItems.push(
          <Col md={4} key={item.eventid}>
            <EventItem
              key={index}
              event={{ ...item, addevent: false }}
              insideDashBoard={insideDashBoard}
              isEventDeleted={this.updateEventDelete} // this props is used for event delete handle
            />
          </Col>
        );
      });
    }

    if (
      DEVELOPMENT_TYPE === "eventify" &&
      // insideDashBoard === false && // Now Create new event button will be visiable from both side (from dashboard and from login)
      user &&
      user.isSuperAdmin &&
      (user.allowedEvent < 0 || user.allowedEvent > user.totalCreatedEvents)
    ) {
      var addeventitem = (
        <Col md={4} key="addevent">
          <EventItem key="0" event={{ themecolor: "", addevent: true }} />
        </Col>
      );

      upCommingEventItems.push(addeventitem);
    }

    return upCommingEventItems;
  }

  renderPastEventItems() {
    let { events, insideDashBoard } = this.props;
    var pastEventItems = [];

    if (events.data && events.data.length > 0) {
      events.data.filter(filterPastEvents).map((item, index) => {
        pastEventItems.push(
          <Col md={4} key={item.eventid}>
            <EventItem
              key={index}
              event={{ ...item, addevent: false }}
              insideDashBoard={insideDashBoard}
              isEventDeleted={this.updateEventDelete} // this props is used for event delete handle
              history={this.props.history}
            />
          </Col>
        );
      });
    }

    return pastEventItems;
  }

  handleMyAccount = () => {
    var menuItem = {
      iconName: LocaleStrings.accountsetting_header_title,
      description: LocaleStrings.accountsetting_header_subtitle,
      bsClass: "accountsettings",
    };
    this.props.selectDashboardMenu(menuItem);

    this.props.markLogin(); // Mark login as true
    this.props.openEventChooser({ showModal: false });
    this.props.initiateCreateEvent({ initiate: false });
    this.props.history.push("/dashboard/accountsettings/billings"); // Redirect to client account setting section. The redirection is mainly happening from login.js file under componentWillMount method
  };

  close = () => {
    this.props.openEventChooser({ showModal: false });
    this.props.initiateCreateEvent({ initiate: false });

    if (this.props.insideDashBoard === false) {
      this.props.logout(this.props.session);
    }
  };

  handleTabs = (key) => {
    this.setState({ selectedTab: key });
  };

  render() {
    let {
      deviceSize,
      events,
      user,
      showEventChooserModal,
      initiateEventCreation,
      insideDashBoard,
      clientuserlimitandexpiry,
    } = this.props;
    // console.log("user :- ", user);
    // console.log("events :- ", events);

    let { selectedTab, eventDeleted } = this.state;
    var title = LocaleStrings.event_chooser_title_string;
    if (initiateEventCreation === true) {
      title = LocaleStrings.event_chooser_create_title_string;
    }
    if (insideDashBoard === true) {
      title = LocaleStrings.event_chooser_changefrominside_title_string;
    }

    let validityexpired = false;

    validityexpired = clientuserlimitandexpiry.validityexpired
      ? clientuserlimitandexpiry.validityexpired
      : false;

    let upcomingEvents = events.data
      ? events.data.filter(filterUpcommingEvents)
      : [];
    let pastEvents = events.data ? events.data.filter(filterPastEvents) : [];

    return (
      <div>
        <Modal
          className="modal-container custom-full-screen-modal"
          show={showEventChooserModal === true ? true : false}
          onHide={this.close}
          animation={true}
          keyboard={false}
          backdrop="static"
          dialogClassName="fullsizedmodal"
        >
          <Modal.Header>
            {initiateEventCreation === true ? (
              <div className="import-modal-title">
                {LocaleStrings.event_chooser_create_title_string}
              </div>
            ) : (
              <div className="import-modal-title">{title}</div>
            )}

            <div className="vertical-align-center gap-3">
              {/* {user.totalAdminEvents == 0 || validityexpired == true ? ( */}
              {user.isSuperAdmin === true ? (
                <button
                  type="button"
                  className="btn-custom-white"
                  onClick={() => this.handleMyAccount()}
                >
                  {LocaleStrings.button_my_account}
                </button>
              ) : (
                ""
              )}

              {!eventDeleted ? (
                <button
                  type="button"
                  className="i-custom-cross-popup"
                  onClick={() => this.close()}
                >
                  <img
                    className="i-custom-small"
                    src="../../style/images/custom-icons/cross-black.png"
                  />
                </button>
              ) : (
                ""
              )}
            </div>
          </Modal.Header>
          <Modal.Body>
            <div
              style={{
                height: deviceSize.height ? deviceSize.height - 125 : "85vh",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              {initiateEventCreation === true ? (
                <Choose
                  // user={this.props.events.data[0]}
                  existinguser={true}
                  insideDashBoard={insideDashBoard}
                />
              ) : (
                <>
                  {!_.isEmpty(events) ? (
                    <Tabs activeKey={selectedTab} onSelect={this.handleTabs}>
                      <Tab
                        eventKey={1}
                        title={`${LocaleStrings.upcoming_event_tab_title_string} (${upcomingEvents.length})`}
                      >
                        <Row className="show-grid">
                          {this.renderUpcomingEventItems()}
                        </Row>
                      </Tab>
                      <Tab
                        eventKey={2}
                        title={`${LocaleStrings.past_event_tab_title_string} (${pastEvents.length})`}
                      >
                        <Row className="show-grid">
                          {this.renderPastEventItems()}
                        </Row>
                      </Tab>
                    </Tabs>
                  ) : (
                    <div className="loader-container">
                      <Loader />
                    </div>
                  )}
                </>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
const filterUpcommingEvents = (item) => {
  let eventdate = new Date(item.eventenddate);
  let todaydate = new Date();

  if (eventdate.setHours(0, 0, 0, 0) >= todaydate.setHours(0, 0, 0, 0)) {
    return item;
  }
};

const filterPastEvents = (item) => {
  let eventdate = new Date(item.eventenddate);
  let todaydate = new Date();

  if (eventdate.setHours(0, 0, 0, 0) < todaydate.setHours(0, 0, 0, 0)) {
    return item;
  }
};

function mapStateToProps(state) {
  return {
    deviceSize: state.deviceSize,
    session: state.session,
    user: state.user,
    events: state.allevents,
    showEventChooserModal: state.showEventChooserModal,
    initiateEventCreation: state.initiateCreateEvent,
    clientuserlimitandexpiry: state.clientuserlimitandexpiry,
  };
}

export default connect(mapStateToProps, {
  openEventChooser,
  initiateCreateEvent,
  logout,
  markLogin,
  fetchtotalaccountusageofclient,
  fetchClientalldetails,
  selectDashboardMenu,
})(EventChooser);
